import {
  ArchiveIcon,
  BellIcon,
  CheckCheckIcon,
  CircleCheckIcon,
  type LucideIcon,
} from 'lucide-react';

export type InboxView = 'all' | 'unread' | 'needs_you' | 'archived';

/**
 * Each empty view's icon and line (spec 141 US6), shared by the bell and the
 * notifications page, which says the same when only a status tab is set.
 */
export const EMPTY_VIEW: Record<InboxView, { icon: LucideIcon; line: string }> =
  {
    all: {
      icon: BellIcon,
      line: 'Nothing needs you. Tasks you create, comment on or follow will report here.',
    },
    needs_you: { icon: CircleCheckIcon, line: 'Nothing is waiting on you.' },
    unread: { icon: CheckCheckIcon, line: 'You’re all caught up.' },
    archived: { icon: ArchiveIcon, line: 'Nothing archived.' },
  };
